export const scrollFn = (element: HTMLElement) => {
  jump(element.getBoundingClientRect().top - 100, { duration: 300 })
}

interface IJumpOptions {
  callback?: () => void
  duration: number | ((distance: number) => number)
  easing?: (timeElapsed: number, start: number, distance: number, duration: number) => number
  offset?: number
}

/**
 * From https://github.com/sitepoint-editors/smooth-scrolling
 */
export function jump(target: string | number, options: IJumpOptions) {
  const start = window.pageYOffset
  const opt = {
    callback: options.callback,
    duration: options.duration,
    easing: options.easing || easeInOutQuad,
    offset: options.offset || 0,
  }
  const distance = typeof target === 'string'
    ? opt.offset + document.querySelector(target)!.getBoundingClientRect().top
    : target
  const duration = typeof opt.duration === 'function'
    ? opt.duration(distance)
    : opt.duration
  let timeStart: number
  let timeElapsed: number


  requestAnimationFrame((time) => { timeStart = time; loop(time) })

  function loop(time: number) {
    timeElapsed = time - timeStart

    window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration))

    if (timeElapsed < duration) {
      requestAnimationFrame(loop)
    }
    else {
      end()
    }
  }

  function end() {
    window.scrollTo(0, start + distance)

    if (typeof opt.callback === 'function') {
      opt.callback()
    }
  }

  // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
  function easeInOutQuad(t: number, b: number, c: number, d: number) {
    t /= d / 2
    if (t < 1) { return c / 2 * t * t + b }
    t--
    return -c / 2 * (t * (t - 2) - 1) + b
  }
}



// WEBPACK FOOTER //
// ./src/utils/scrollFn.ts